import { Button, ModalWindow } from '@cian/ui-kit';

import * as styles from './index.css';

export interface IChatModalOwnOfferProps {
  isOpen: boolean;
  onClose(): void;
}
export function ChatModalOwnOffer({ isOpen, onClose }: IChatModalOwnOfferProps) {
  return (
    <ModalWindow
      title="Вы не можете написать сообщение самому себе"
      open={isOpen}
      onClose={onClose}
      content={
        <div className={styles['actions']}>
          <Button onClick={onClose}>Закрыть</Button>
        </div>
      }
    />
  );
}
